// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  notificationId: __t.u64().primaryKey().name("notification_id"),
  userIdentity: __t.identity().name("user_identity"),
  notificationType: __t.string().name("notification_type"),
  title: __t.string(),
  body: __t.string(),
  data: __t.option(__t.string()),
  isRead: __t.bool().name("is_read"),
  createdAt: __t.timestamp().name("created_at"),
});
